import { PropsWithChildren } from "react";

export function ContactUsPageLayout({ children }: PropsWithChildren) {
  return (
    <>
      <div className="relative mx-auto w-full max-w-[952px] bg-white px-4 py-0 xs:py-16 md:px-0">
        {children}
      </div>
    </>
  );
}
